import HeaderPage from "../../components/lines-managements/header/HeaderPage";
import ServiceFeesTable from "../../components/service-fees";

const ServiceFeesPage: React.FC = () => {
  return (
    <>
      <HeaderPage
        link={{
          to: "add",
          children: "Shto konfigurim të ri",
          state: ["Service Fees", "Shto konfigurim të ri"]
        }}
      />
      <ServiceFeesTable />
    </>
  );
};

export default ServiceFeesPage;
